/* eslint-disable */
export default class Feature {
    constructor(id, geometryData, propertiesData, valueKeys) {
        this.type = 'Feature';
        this.id = id ? String(id).toLowerCase() : null;
        this.geometry = geometryData;
        this.properties = {
            name: '',
            values: {},
            extras: {},
        };

        this.setProperties(id, propertiesData, valueKeys);
    }

    setProperties(id, propertiesData, valueKeys) {
        const properties = propertiesData || {};

        this.setName(id, properties);
        this.setValues(properties, valueKeys);
        this.setExtras(properties, valueKeys);
    }

    setName(id, properties) {
        this.properties.name = properties.name || id;
    }

    setValues(properties, valueKeys) {
        const keys = valueKeys || [];

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            this.properties.values[key] = properties[key] || null;
        }
    }

    setExtras(properties, valueKeys) {
        const coreKeys = ['name', 'id'];
        const data = properties || {};
        const excludedKeys = Array.isArray(valueKeys) ? valueKeys.concat(coreKeys) : coreKeys;

        //Object.keys(data).forEach((key) => {
        //    if (excludedKeys.indexOf(key) === -1) {
        //        this.properties.extras[key] = data[key];
        //    }
        //});

        const dataKeys = Object.keys(data);
        const dataKeysLength = dataKeys.length;
        for (let i = 0; i < dataKeysLength; i++) {
            const key = dataKeys[i];
            if (excludedKeys.indexOf(key) === -1) {
                this.properties.extras[key] = data[key];
            }
        }
    }

    hasAllValues() {
        let validity = true;
        const values = this.properties.values;

        //Object.keys(values).forEach((key) => {
        //    const value = values[key];
        //    if (typeof value === undefined) {
        //        validity = false;
        //    }
        //});

        const valueKeys = Object.keys(values);
        const valueKeysLength = valueKeys.length;
        for (let i = 0; i < valueKeysLength; i++) {
            const value = values[valueKeys[i]];
            if (typeof value === undefined) {
                validity = false;
            }
        }

        return validity;
    }
}
